import { render, staticRenderFns } from "./RulesList.vue?vue&type=template&id=f81cb0b4&scoped=true"
import script from "./RulesList.vue?vue&type=script&lang=js"
export * from "./RulesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81cb0b4",
  null
  
)

export default component.exports